export const URLS = {
    RICOH: '/ricoh',
    ROOT: '/',
};

export default {
    URLS,
};
